export const SEGMENT_FILLS = [
  '#1E7F6E',
  '#15202B',
  '#C2413B',
  '#1B3448',
  '#B98A1F',
  '#0F2B30',
]

/** Pick a repeating fill so no two neighbours (including the wrap seam) match. */
export function fillFor(index: number, total: number): string {
  const palette = SEGMENT_FILLS
  if (total === 1) return palette[0]
  let i = index % palette.length
  if (index === total - 1 && i === 0) i = 1
  return palette[i]
}

export function polar(
  cx: number,
  cy: number,
  r: number,
  deg: number,
): [number, number] {
  const rad = ((deg - 90) * Math.PI) / 180
  return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)]
}

export function arcPath(
  cx: number,
  cy: number,
  r: number,
  start: number,
  end: number,
): string {
  const [x1, y1] = polar(cx, cy, r, start)
  const [x2, y2] = polar(cx, cy, r, end)
  const large = end - start > 180 ? 1 : 0
  return `M ${cx} ${cy} L ${x1.toFixed(2)} ${y1.toFixed(2)} A ${r} ${r} 0 ${large} 1 ${x2.toFixed(2)} ${y2.toFixed(2)} Z`
}

/**
 * Absolute rotation (degrees, clockwise) that lands segment `index` under the
 * pointer at 12 o'clock, always spinning forward from `current`.
 */
export function targetRotation(
  current: number,
  index: number,
  count: number,
  turns = 5,
): number {
  const seg = 360 / count
  const center = index * seg + seg / 2
  const base = (360 - (center % 360)) % 360
  const delta = (((base - current) % 360) + 360) % 360
  const jitter = (Math.random() - 0.5) * seg * 0.55
  return current + delta + turns * 360 + jitter
}

export function labelSize(count: number): number {
  if (count <= 6) return 17
  if (count <= 10) return 15
  if (count <= 16) return 13
  if (count <= 24) return 11
  return 9
}

export function truncate(name: string, count: number): string {
  const max = count <= 8 ? 16 : count <= 16 ? 13 : 10
  return name.length > max ? `${name.slice(0, max - 1)}…` : name
}
